import React, { useEffect } from "react";
import about from "./service/images/about.png";
import male from "./service/images/male-removebg-preview.png";
import female from "./service/images/female-removebg-preview.png";
import maleco from "./service/images/male-co.png";
import femaleco from "./service/images/female-co.png";
import TeamCard from "../Components/Cards/TeamCard";
import Marquee from "react-fast-marquee";

export default function AboutUs() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the component is mounted
  }, []);
  const teamMembers = [
    {
      name: "Santhoshkumar",
      role: "Web Developer",
      image: male, // Placeholder image
    },
    {
      name: "Shanmugaraj",
      role: "Web Developer",
      image: male, // Placeholder image
    },
    {
      name: "Vasanthakumar",
      role: "Web Developer",
      image: male, // Placeholder image
    },
    {
      name: "Sivashankar",
      role: "UI/UX Designer",
      image: male, // Placeholder image
    },
    {
      name: "Subaleka",
      role: "UI/UX Designer",
      image: female, // Placeholder image
    },
    {
      name: "Thevanathan",
      role: "UI/UX Designer",
      image: male, // Placeholder image
    },
    {
      name: "Arun Kumar",
      role: "UI/UX Designer",
      image: male, // Placeholder image
    },
    {
      name: "Aisha",
      role: "UI/UX Designer",
      image: female, // Placeholder image
    },
    {
      name: "Dinesh Kumar",
      role: "UI/UX Designer",
      image: male, // Placeholder image
    },
  ];

  return (
    <div className="contact-page  flex flex-col items-center justify-center mt-24">
      {/* Hero Section */}
      <section className="hero w-full my-20  gap-10  flex md:flex-nowrap flex-wrap max-w-[90%]  justify-center items-center text-start  text-white">
        <div className="md:w-1/2  px-5 md:pl-10  md:order-1 order-2">
          <h1 className="text-5xl text-center md:text-left mb-6 font-bold  bg-clip-text text-transparent bg-gradient-to-r from-[#F9B5FB]  to-[#921196]">
            Zenhook
          </h1>
          <div className=" mt-2 text-base font-montserrat font-thin flex flex-col gap-5 ">
            <p className="!font-thin">
              Zenhook was founded by a dynamic junior and senior duo, combining
              their expertise to create a digital agency that stands out through
              innovation and creativity. Inspired by our roots in teamwork and
              dedication, we provide top-tier website development, e-commerce
              solutions, and video marketing services designed to elevate
              businesses in the digital world.
            </p>

            <p>
              Our strength lies not only in our leadership but also in our
              quality-driven team. Each member of the Zenhook team brings their
              unique skills and dedication to ensure that every project is
              crafted with precision, attention to detail, and a deep
              understanding of our clients' goals. Together, we work tirelessly
              to deliver solutions that are both creative and results-oriented.
            </p>

            <p>
              At Zenhook, we live by our motto: "We win for our clients."
              Whether you're a startup or an established business, we’re here to
              deliver impactful digital experiences that drive growth and
              success.
            </p>
          </div>
        </div>
        <div className="md:w-1/2 order-1 h-full items-center flex justify-center">
          {" "}
          <img
            src={about}
            alt="about-img"
            className="w-[80%] h-[80%] rounded-[150px]"
          ></img>
        </div>
      </section>

      {/* Team Section */}
      <div className="w-full flex flex-col items-center justify-center mb-20">
        {/* Intro Section */}
        <div className="md:max-w-[50%] flex flex-col items-center gap-3 mb-10">
          <p className="font-serif text-2xl mx-10 md:text-5xl text-white tracking-wide text-center">
            Meet the team that makes the{" "}
            <span className="font-extralight font-serif italic bg-clip-text text-transparent bg-gradient-to-r from-[#F9B5FB]  to-[#921196]">
              magic
            </span>{" "}
            happen
          </p>
          <p className="text-[15px] max-w-[50%] tracking-wide font-thin text-white/50 text-center">
            Our dedicated crew behind every design choice and every line of code
          </p>
        </div>
        <div className="flex mb-10 gap-10 flex-col md:flex-row">
          <TeamCard
            img={maleco}
            name={"Fakir"}
            role={"Founder of Zenhook"}
          />
          <TeamCard
            name={"Sowmiya"}
            img={femaleco}
            role={"Founder of Zenhook"}
          />
        </div>

        {/* Team Section with Marquee */}
        <div className="w-full flex justify-between">
          <Marquee gradient={false} speed={50}>
            <div className="flex gap-10 pl-10">
              {teamMembers.map((mem, index) => (
                <TeamCard
                  key={index}
                  name={mem.name}
                  role={mem.role}
                  img={mem.image}
                />
              ))}
            </div>
          </Marquee>
        </div>
      </div>
    </div>
  );
}
